import { render, staticRenderFns } from "./create-or-edit-field.vue?vue&type=template&id=2d341a70&scoped=true&"
import script from "./create-or-edit-field.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-field.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-field.vue?vue&type=style&index=0&id=2d341a70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d341a70",
  null
  
)

export default component.exports